import { IClassroomResource } from "@sol/sdk";

export const isClassroomWebinarAvailable = <T extends IClassroomResource>(classroom?: T): classroom is T => {
    return classroom?.active ?? false;
};
